import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'


import Login from '../views/Auth/Login.vue'
import Logout from '../views/Auth/Logout.vue'

import Me from '../views/Auth/Me.vue'

import Lang from '../views/Sysytem/Langs/Index.vue'

import Category from '../views/Sysytem/Categories/Index.vue'
import AddCategory from '../views/Sysytem/Categories/AddCategory.vue'
import EditCategory from '../views/Sysytem/Categories/EditCategory.vue'

import Users from '../views/Users/Index.vue'
import AddUser from '../views/Users/AddUser.vue'
import EditUser from '../views/Users/EditUser.vue'

import Authors from '../views/Authors/Index.vue'

import Publishers from '../views/Publishers/Index.vue'

import Books from '../views/Books/Index.vue'
import AddBook from '../views/Books/AddBook.vue'
import UploadBook from '../views/Books/UploadBook.vue'


import DetailsBook from '../views/Books/DetailsBook.vue'
import ReadBook from '../views/Books/ReadBook.vue'
import Microes from '../views/Micros/index.vue'
import AddMicro from '../views/Micros/add.vue'
import EditMicro from '../views/Micros/edit.vue'


import ReadMicros from '../views/Micros/Read.vue'




Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'Home',
        component: Home,
        meta: {
            requiresAuth: true
        }
    },

    // Login Route
    {
        path: '/login',
        name: 'Login',
        component: Login,
        props: true,
        meta: {
            requiresAuth: false
        }
    },

    {
        path: '/logout',
        name: 'Logout',
        component: Logout,
        meta: {
            requiresAuth: true
        }
    },

    // my Profile 
    {
        path: '/me',
        name: 'Me',
        component: Me,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // Langs Routes
    {
        path: '/languages',
        name: 'Lang',
        component: Lang,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // Categories Routes
    {
        path: '/categories',
        name: 'Category',
        component: Category,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/category/add',
        name: 'AddCategory',
        component: AddCategory,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/category/add/:parentID',
        name: 'AddCategoryChild',
        component: AddCategory,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/category/edit/:categoryID',
        name: 'EditCategory',
        component: EditCategory,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // Users Routes
    {
        path: '/users',
        name: 'Users',
        component: Users,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/user/add',
        name: 'AddUser',
        component: AddUser,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/user/edit/:userID',
        name: 'EditUser',
        component: EditUser,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // author Routes
    {
        path: '/authors',
        name: 'Authors',
        component: Authors,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // publisher Routes
    {
        path: '/publishers',
        name: 'Publishers',
        component: Publishers,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // Books Routes
    {
        path: '/books',
        name: 'Books',
        component: Books,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/book/add',
        name: 'AddBook',
        component: AddBook,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/book/details/:bookID',
        name: 'DetailsBook',
        component: DetailsBook,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/book/read/book/:bookID/version/:versionID',
        name: 'ReadBook',
        component: ReadBook,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    // add book new

    {
        path: '/book/upload',
        name: 'UploadBook',
        component: UploadBook,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/microes',
        name: 'Microes',
        component: Microes,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/micro/add',
        name: 'AddMicro',
        component: AddMicro,
        props: true,
        meta: {
            requiresAuth: true
        }
    },

    {
        path: '/micro/:id/:key',
        name: 'ReadMicros',
        component: ReadMicros,
        props: true,
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/edit/micro/:id',
        name: 'EditMicro',
        component: EditMicro,
        props: true,
        meta: {
            requiresAuth: true
        }
    },



    
    






]

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

export default router